import { useMemo } from 'react';
import { useCurrentUser } from '@hooks/users';

export const useObjectiveCompletion = (objectiveId: number) => {
  const { data: user } = useCurrentUser();

  const isCompleted = useMemo(() => {
    if (!user || !user.completedObjectives) {
      return false;
    }

    return user.completedObjectives.some((completed) => completed.id === objectiveId);
  }, [user, objectiveId]);

  const progress = isCompleted ? 100 : 0;

  return { isCompleted, progress };
};
